<template>
  <div class="main">
    <div class="header">
      <div class="btn-doing" @click="sidebarToggle"><i :class="[isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold']"></i></div>
      <div class="logo" @click="goIndex('index')">
        <!-- <img src="../../assets/images/logo.png" alt="logo" style="width: 25%; margin-right: 10px;"> -->
        <!-- <span style="padding: 0 10px;">|</span> -->
        懂球帝数据运营后台
      </div>
      <div class="right">
        <el-dropdown style="float: right; color: rgba(255,255,255,0.75); margin-right: 10px;">
          <span class="header-btn">
            <img src="../../assets/images/icon_head.png" alt="head">{{ user_name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="jumpView('UsersView')"><i style="padding-right: 8px" class="fa fa-cog"></i>账号信息</el-dropdown-item>
            <el-dropdown-item @click.native="logout"><i style="padding-right: 8px" class="fa fa-key"></i>退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="type">
          账号类型：广告主
        </div>
        <div class="message" @click="showMessage">
          <img src="../../assets/images/icon_talk.png" alt="message">
          <div class="num" v-if="parseInt(count) <= 0"></div>
        </div>
      </div>
    </div>
    <div class="app">
      <div class="aside">
        <div class="menu">
          <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" background-color="#FBFAFF" text-color="#666666" active-text-color="#17A34A" :collapse="isCollapse" :unique-opened="true">
            <el-menu-item index="1" @click="jumpView('HomeView')">
              <i class="el-icon-takeaway-box" style="font-size: 14px"></i>
              <span class="nav-font">首页</span>
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-document" style="font-size: 15px"></i>
                <span class="nav-font">物料管理</span>
              </template>
              <el-menu-item index="2-1" @click="jumpView('MaterialWapView')">WAP端</el-menu-item>
              <el-menu-item index="2-2" @click="jumpView('MaterialPcView')">PC端</el-menu-item>
            </el-submenu>
            <el-menu-item index="3" @click="jumpView('LinkView')">
              <i class="el-icon-link" style="font-size: 15px"></i>
              <span class="nav-font">推广链接</span>
            </el-menu-item>
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-c-scale-to-original" style="font-size: 15px"></i>
                <span class="nav-font">计划中心</span>
              </template>
              <el-menu-item index="4-1" @click="jumpView('PlanView')">广告组</el-menu-item>
              <el-menu-item index="4-2" @click="jumpView('AdvView')">广告计划</el-menu-item>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-data-line" style="font-size: 15px"></i>
                <span class="nav-font">报表统计</span>
              </template>
              <el-menu-item index="5-1" @click="jumpView('DataView')">效果数据</el-menu-item>
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">
                <i class="el-icon-money" style="font-size: 15px"></i>
                <span class="nav-font">财务中心</span>
              </template>
              <el-menu-item index="6-1" @click="jumpView('UsersView')">账户信息</el-menu-item>
              <el-menu-item index="6-2" @click="jumpView('BillView')">账单</el-menu-item>
              <el-menu-item index="6-3" @click="jumpView('LogView')">操作日志</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="app-body">
        <div id="mainContainer" class="main-container" v-loading="false" element-loading-text="loading..." element-loading-background="#FFFFFF">
          <div class="layout-right jm-animate">
            <el-scrollbar style="height: 100%;">
              <component :is="current"
                @add_plan="addPlan"
                :type="type"
                :view="view"
                :editItem="editItem"
                @form_call_back="form_call_back"
                @edit_call_back="edit_call_back"
                @adv_lists_call_back="adv_lists_call_back"
                :plan_id="plan_id"
              ></component>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /* global require */
  data() {
    return {
      defaultActive: '1',
      isCollapse: false,
      adminInfo: [],
      current: 'HomeView',
      currentIndex: 0,
      user_name: '',
      type: 'add',
      view: 'plan',
      plan_id: 0,
      editItem: [],
      count: 0
    };
  },
  created() {
    this.$function.hiddenLoading();
    this.getUserInfo();
  },
  methods: {
    showMessage() {
      this.$http.post('/trader/index/setCount').then(res => {
        if (res.code === 200) {
          this.count = 1;
          this.jumpView('MessageView');
        }
      });
    },
    sidebarToggle(e) {
      e.preventDefault();

      if (this.isCollapse) {
        document.body.classList.remove('sidebar-hidden');
        this.isCollapse = false;
      } else {
        document.body.classList.add('sidebar-hidden');
        this.isCollapse = true;
      }
    },
    getUserInfo() {
      this.$http.post('/trader/index/getUserInfo').then(res => {
        if (res.code === 200 && res.data.user_name !== undefined) {
          sessionStorage.setItem('user_info', JSON.stringify(res.data));
          this.user_name = res.data.user_name;
          this.count = res.data.count;
        } else {
          this.$message.error('未找到该用户，请联系管理员');
          this.logout();
        }
      });
    },
    jumpView(name) {
      const titles = {
        HomeView: '首页',
        LinkView: '推广链接',
        MaterialWapView: 'WAP物料端',
        MaterialPcView: 'PC物料端',
        PlanView: '广告组',
        AdvView: '广告计划',
        DataView: '效果数据',
        UsersView: '账户信息',
        BillView: '账单',
        LogView: '操作日志',
        MessageView: '消息中心',
        FormView: '新建广告',
        AdvListsView: '广告组'
      };
      if (this.current !== name) {
        document.title = titles[name];
        this.$function.showLoading();
        this.current = name;
      }
    },
    logout() {
      sessionStorage.removeItem(this.$Config.tokenKey);
      this.$router.push({ path: '/login' });
    },
    addPlan(view) {
      this.view = view;
      this.type = 'add';
      this.current = 'formView';
    },
    form_call_back(view) {
      this.current = view === 'plan' ? 'planView' : (view === 'adv' ? 'AdvView' : 'AdvListsView');
    },
    edit_call_back(item) {
      this.view = 'adv';
      this.type = 'edit';
      this.editItem = item;
      this.current = 'formView';
    },
    adv_lists_call_back(plan_id) {
      this.plan_id = plan_id;
      this.current = 'AdvListsView';
    }
  },
  mounted() {

  },
  components: {
    HomeView: resolve => require(['@/views/Index/Lists.vue'], resolve),
    LinkView: resolve => require(['@/views/Link/Lists.vue'], resolve),
    MaterialWapView: resolve => require(['@/views/Material/wap.vue'], resolve),
    MaterialPcView: resolve => require(['@/views/Material/pc.vue'], resolve),
    PlanView: resolve => require(['@/views/Plan/Lists.vue'], resolve),
    AdvView: resolve => require(['@/views/Adv/Lists.vue'], resolve),
    AdvListsView: resolve => require(['@/views/AdvLists/Lists.vue'], resolve),
    FormView: resolve => require(['@/views/Form/Lists.vue'], resolve),
    UsersView: resolve => require(['@/views/Users/Lists.vue'], resolve),
    BillView: resolve => require(['@/views/Bill/Lists.vue'], resolve),
    LogView: resolve => require(['@/views/Log/Lists.vue'], resolve),
    MessageView: resolve => require(['@/views/Message/Lists.vue'], resolve),
    DataView: resolve => require(['@/views/Data/Lists.vue'], resolve)
  }
};
</script>
<style lang="less">
@import '../../assets/css/style.less';
@header-bg: #17A34A;

.el-menu .is-active {
  color: #17A34A !important;
  // background-color: #333333 !important;
}
.el-submenu__title:hover {
  background-color: none !important;
}

.sidebar-hidden {
  .aside .sidebar-toggle .icon-left {
    transform: rotate(180deg);
  }
  .main .app-body {
    margin-left: 64px;
  }
}

.nav {
  height: 50px;
  line-height: 50px;
  color: #999;
  text-align: center;
  font-size: 14px;
  padding: 0 20px;
  position: relative;
}

.nav:hover {
  cursor: pointer;
  color: #ffffff;
}

.el-menu-item i {
  color: #666666;
}

.el-menu--inline {
  .el-menu-item {
    background: none !important;
  }
  .el-menu-item:focus,
  .el-menu-item:hover,
  .el-submenu__title:hover {
    color: #17A34A !important;
    // font-weight: bold !important;
    background-color: none !important;
  }
  .is-active {
    color: #17A34A !important;
    // background-color: #333333 !important;
  }
}

.selectcd {
  color: #fff;
}

.selectcd::after {
  content: '';
  display: inline-block;
  width: 24px;
  height: 4px;
  background: #2F88FF;
  border-radius: 2px;
  position: absolute;
  bottom: 13px;
  left: 50%;
  transform: translateX(-50%);
}

// .el-menu-item:focus,
// .el-menu-item:hover,
// .el-submenu__title:hover {
//   background-color: #FFF !important;
// }

.main {
  display: flex;
  .el-menu {
    border-right: none !important;
  }
  .el-menu:not(.el-menu--collapse) {
    width: 190px;
    height: 100%;
  }
  .app {
    width: 100%;
    background: #FFFFFF;
  }
  .aside {
    position: fixed;
    margin-top: 50px;
    z-index: 10;
    background-color: #FFFFFF;
    transition: all 0.3s ease-in-out;
    .menu {
      overflow-y: auto;
      height: calc(100vh);
    }
  }
  .app-body {
    // width: calc(100% - 190px);
    margin-left: 190px;
    -webkit-transition: margin-left 0.3s ease-in-out;
    transition: margin-left 0.3s ease-in-out;
  }
  .main-container {
    width: 100%;
    height: calc(100vh - 50px);
    overflow-y: auto;
    position: relative;
    margin-top: 50px;
    .layout-right {
      width: 100%;
      // width: 1200px;
      margin: 0 auto;
    }
  }
}

.header {
  width: 100%;
  position: fixed;
  display: flex;
  height: 50px;
  background-color: @header-bg;
  box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  z-index: 10;
  .btn-doing {
    height: 50px;
    width: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    background: #17A349;
    cursor: pointer;
  }
  .logo {
    width: 280px;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    background-color: @header-bg;
    -webkit-transition: width 0.35s;
    transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    font-size: 14px;
    .min {
      display: none;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .nav-body {
    width: calc(100% - 460px);
    display: flex;
  }
  .right {
    position: absolute;
    right: 0;
    margin-right: 50px;
    display: flex;
    align-items: center;
    .type {
      color: #fff;
      margin: 0 25px;
      font-size: 14px;
      width: 120px;
    }
    .message {
      margin-left: 30px;
      position: relative;
      cursor: pointer;
      .num {
        padding: 0 5px;
        font-size: 12px;
        position: absolute;
        top: -10px;
        right: -10px;
        color: #fff;
        background-color: red;
        border-radius: 50%;
      }
    }
  }
  .header-btn {
    overflow: hidden;
    height: 50px;
    display: flex;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    padding: 0 14px;
    align-items: center;
    color: #fff;
    img {
      margin-right: 10px;
    }
    .el-badge__content {
      top: 14px;
      right: 7px;
      text-align: center;
      font-size: 9px;
      padding: 0 3px;
      background-color: #00a65a;
      color: #fff;
      border: none;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: 0.25em;
    }
  }
  .header-btn:hover {
    background-color: @header-bg;
  }
}
.menu {
  border-right: none;
  background: #F5F5F5;
}
.el-menu--vertical {
  min-width: 190px;
}
</style>
